<template>
    <div id="login">
      <main>
          <LoginTable mainStyle="left:10%;width:80%;" inputStyle="width:50%;" />
      </main>
    </div>
  </template>
  
  <script>
  import LoginTable from "./LoginTable.vue";
  
  export default {
    name: "LoginMain",
    components: {
        LoginTable,
    },
    mounted:() => {

    },
  };
  </script>
  
  <style>
  #login {
    background: url("https://back.vinapp.co/banner-login.jpg") center center;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  </style>